import { render, staticRenderFns } from "./jiankang-list.vue?vue&type=template&id=6a820bf6&scoped=true&"
import script from "./jiankang-list.vue?vue&type=script&lang=ts&"
export * from "./jiankang-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a820bf6",
  null
  
)

export default component.exports